// How many items could be created or updated within a single animation frame tick
export const MAX_UPDATES_PER_FRAME = 20;

// How much time to spend before expanding a currently focused item, in ms
export const ITEM_FOCUS_TIMEOUT_MS = 800;

export const SET_X_SIGNAL = 'set_x';

export const SET_Y_SIGNAL = 'set_y';
